import { Caption, Header, OuterContainer } from "./styles";
import styled from "styled-components";

const BuyContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  text-align: left;
`;

const Section = styled.div`
  margin-bottom: 40px;
`;

const LinkList = styled.ul`
  margin: 15px 0;
  padding-left: 20px;
`;

const LinkItem = styled.li`
  margin-bottom: 12px;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
`;

const StoreLink = styled.a`
  color: #0066cc;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

const FormatNote = styled.span`
  color: #666;
  font-weight: normal;
  margin-left: 8px;
`;

const Description = styled.p`
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  margin-bottom: 20px;
  color: #333;
`;

const SectionHeader = styled(Header)`
  font-size: 18px;
  margin-bottom: 15px;
`;

const DisabledText = styled.span`
  color: #666;
`;

export default function Buy() {
  return (
    <OuterContainer>
      <BuyContainer>
        <Header>BUY SENTIENTS</Header>

        <Description>
          The Sentients Core Rulebook is available in both hardcover and PDF
          formats from multiple retailers. Choose your preferred store below:
        </Description>

        <Section>
          <SectionHeader>DIRECT</SectionHeader>
          <LinkList>
            <LinkItem>
              <StoreLink
                href="https://tedbotgames.bigcartel.com/product/sentients-hardcover?utm_source=sentientsrpg&utm_medium=website&utm_campaign=buy_page"
                target="_blank"
                rel="noopener"
              >
                Big Cartel
              </StoreLink>
              <FormatNote>(Hardcover)</FormatNote>
            </LinkItem>
            <LinkItem>
              <StoreLink
                href="https://www.drivethrurpg.com/en/product/515240/sentients-the-rpg-of-artificial-consciousness?utm_source=sentientsrpg&utm_medium=website&utm_campaign=buy_page"
                target="_blank"
                rel="noopener"
              >
                DriveThruRPG
              </StoreLink>
              <FormatNote>(PDF)</FormatNote>
            </LinkItem>
            <LinkItem>
              <StoreLink
                href="https://www.amazon.com/dp/B0FKTQ92J1?utm_source=sentientsrpg&utm_medium=website&utm_campaign=buy_page"
                target="_blank"
                rel="noopener"
              >
                Amazon
              </StoreLink>
              <FormatNote>(Hardcover)</FormatNote>
            </LinkItem>
            <LinkItem>
              <StoreLink
                href="https://t3db0t.itch.io/sentients-the-rpg-of-artificial-consciousness?utm_source=sentientsrpg&utm_medium=website&utm_campaign=buy_page"
                target="_blank"
                rel="noopener"
              >
                Itch.io
              </StoreLink>
              <FormatNote>(PDF)</FormatNote>
            </LinkItem>
            <LinkItem>
              <StoreLink
                href="https://t3dbot.gumroad.com/l/sentients-core-rulebook-pdf?utm_source=sentientsrpg&utm_medium=website&utm_campaign=buy_page"
                target="_blank"
                rel="noopener"
              >
                Gumroad
              </StoreLink>
              <FormatNote>(PDF)</FormatNote>
            </LinkItem>
          </LinkList>
        </Section>

        <Section>
          <SectionHeader>DISTRIBUTORS</SectionHeader>
          <LinkList>
            <LinkItem>
              <StoreLink
                href="https://www.indiepressrevolution.com/xcart/Sentients-Print-PDF.html?utm_source=sentientsrpg&utm_medium=website&utm_campaign=buy_page"
                target="_blank"
                rel="noopener"
              >
                Indie Press Revolution
              </StoreLink>
            </LinkItem>
            <LinkItem>
              <DisabledText>Studio2</DisabledText>
              <FormatNote>(Coming Soon)</FormatNote>
            </LinkItem>
          </LinkList>
        </Section>

        <Section>
          <SectionHeader>CROWDFUNDING</SectionHeader>
          <LinkList>
            <LinkItem>
              <StoreLink
                href="https://www.kickstarter.com/projects/t3db0t/sentients-the-role-playing-game-of-artificial-consciousness?utm_source=sentientsrpg&utm_medium=website&utm_campaign=buy_page"
                target="_blank"
                rel="noopener"
              >
                Kickstarter
              </StoreLink>
              <FormatNote>(Completed)</FormatNote>
            </LinkItem>
          </LinkList>
        </Section>

        <Caption>GAME DESIGN BY TED HAYES</Caption>
      </BuyContainer>
    </OuterContainer>
  );
}
